<template>
  <div class="h5bg">
    <div style="height: 10px;"></div>
    <div style="padding:0px 0px;background-color: #fff; margin:0 10px; border-radius: 6px;">
      <el-form ref="form" :model="enterInfo" label-position="top" label-width="180px">
        <div class="section-title flexStart"><span></span>企业信息</div>
        <el-row>
          <el-form-item label="企业名称" style="margin-bottom: 0;" required>
            <!-- <el-input v-model="enterInfo.firm_name" @blur="checkTyc" placeholder="请输入企业全称"></el-input> -->
            <div class="cell flexBetween flex_1">
              <el-select v-model="enterInfo.firm_name" size="mini" ref="selectSearch"
                style="width: 100%;font-size:16px;" filterable remote placeholder="请输入企业名称点击查询拉取数据"
                :remote-method="remoteMethod" @change="saveNewCompany" no-match-text="请输入企业名称点击查询拉取数据"
                no-data-text="请点击查询按钮拉取数据">
                <el-option v-for="(item, index) in houxuanList" :key="index" :value="item.name">
                  <span style="float: left">{{ item.name }}</span>
                </el-option>
              </el-select>
              <el-button size="mini" type="primary" plain @click="qccApiData">查询</el-button>
            </div>
          </el-form-item>
          <el-row>
            <el-form-item label="社会统一信用代码" style="margin-bottom: 0;" required>
              <el-input v-model="enterInfo.firm_num" placeholder="社会统一信用代码"></el-input>
            </el-form-item>
          </el-row>
          <el-form-item label="企业地址详情" style="margin-bottom: 0;" required>
            <el-input v-model="enterInfo.address" placeholder="请输入企业地址详情"></el-input>
          </el-form-item>
          <el-row>
          </el-row>
          <el-form-item label="企业联系人" style="margin-bottom: 0;" required>
            <el-input v-model="enterInfo.firm_principal" placeholder="请输入企业联系人"></el-input>
          </el-form-item>
          <el-row>
          </el-row>
          <el-form-item label="企业联系人电话" style="margin-bottom: 0;" required>
            <el-input v-model="enterInfo.tel" placeholder="请输入企业联系人电话,请输入数字"></el-input>
          </el-form-item>
        </el-row>
        <div class="section-title flexStart"><span></span>岗位信息</div>
        <div style="padding:10px;margin-top: 10px; position: relative;" v-for="(pos, i) in job_info_list" :key="i">
          <div class="section-title1 flexStart">
            <span></span>岗位{{ i + 1 }}
            <div class="remove-btn" v-if="job_info_list.length > 1 && !loading" @click="removeJob(i)">
              <img :src="'./img/remove.png'" />
            </div>
          </div>
          <div class="tags">
            <span v-if="pos.check_status == 0" class="style0">审核中</span>
            <span v-if="pos.check_status == 1" class="style1">审核通过</span>

            <el-tooltip class="item" effect="dark" :content="pos.check_desc" placement="top-end">
              <span v-if="pos.check_status == 2" class="style2">审核不通过</span>
            </el-tooltip>


            <span v-if="pos.check_status == 3" class="style3">已关闭</span>
          </div>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item label="提供岗位名称" style="margin-bottom: 0;">
                <el-input v-model="pos.job_name" placeholder="岗位名称"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="招聘人数" style="margin-bottom: 0;">
                <el-input v-model="pos.need_num" placeholder="招聘人数"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="工作城市" style="margin-bottom: 0;">
                <el-input v-model="pos.city" placeholder="工作城市"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item label="工作地点" style="margin-bottom: 0;">
                <el-input v-model="pos.word_addr" placeholder="工作地点"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="经验和学历" style="margin-bottom: 0;">
                <div class="flexStart" style="width:100%;">
                  <el-select v-model="pos.experience" placeholder="请选择经验">
                    <el-option :label="item.param_desc" v-for="(item, idx) in gzjy" :key="idx"
                      :value="item.param_value / 1"></el-option>
                  </el-select>

                  <el-select v-model="pos.eduaction" placeholder="请选择学历">
                    <el-option :label="item.param_desc" v-for="(item, idx) in xlyq" :key="idx"
                      :value="item.param_value / 1"></el-option>
                  </el-select>
                </div>
              </el-form-item>

            </el-col>
            <el-col :span="12">
              <el-form-item label="外语要求" style="margin-bottom: 0;">
                <el-select v-model="pos.english_level" placeholder="请选择外语要求">
                  <el-option :label="item.param_desc" v-for="(item, idx) in wyyq" :key="idx"
                    :value="item.param_value / 1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计算机要求" prop="computer_level">
                <el-select v-model="pos.computer_level" placeholder="请选择计算机要求">
                  <el-option :label="item.param_desc" v-for="(item, idx) in jsjyq" :key="idx"
                    :value="item.param_value / 1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="薪资范围" prop="pay">
                <el-select v-model="pos.pay" placeholder="请选择薪资范围">
                  <el-option :label="item.param_desc" v-for="(item, idx) in xzfw" :key="idx"
                    :value="item.param_value / 1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="岗位描述" prop="job_desc">
                <el-input style="width:100%" type="textarea" placeholder="请输入岗位内容或要求" v-model="pos.job_desc"
                  show-word-limit :autosize="{ minRows: 4, maxRows: 20 }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <div style="height: 10px;"></div> -->
          <!-- <div class="add-btn" v-if="i == job_info_list.length - 1 && !loading" @click="addJob">
            <img :src="'./img/add_blue.png'" />
          </div> -->
        </div>

        <div class="btn-container">
          <el-button type="primary" @click="addJob" plain icon="el-icon-plus" size="mini">新增岗位</el-button>
        </div>

        <!-- <el-form-item v-if="pmid == 216" label="上传图片" required>
          <div style="margin-left:0px;margin-bottom:8px;font-size:14px;line-height:20px;color:#909399">
            请上传营业执照和企业相关照片（办公场所、宿舍、食堂）</div>
          <div style="display:inline-block; margin-right:10px;vertical-align: top; position: relative;"
            v-for="(img, idx) in fileList" :key="idx">
            <el-image style="width: 100px; height: 100px" :src="img.fileUrl || img.src"
              :preview-src-list="[img.fileUrl || img.src]" img="cover"></el-image>

            <div class="imgremove" @click="removeImg(idx)"><i class="el-icon-remove"></i></div>
          </div>

          <div style="display:inline-block;vertical-align: top;">

            <el-upload style="display: inline-block; margin-right: 20px" action="" :http-request="uploadOss"
              :on-success="uploadFiles" :show-file-list="false" name="image" accept="image/png, image/jpeg">
              <div class="imgaddbtn">
                ＋
              </div>
            </el-upload>
          </div>
        </el-form-item> -->

        <div class="btn-container">
          <el-button v-if="!loading" type="primary" @click="saveForm" :loading="loading"
            style="width: 80%; margin-top: 50px; margin-bottom: 50px;">提交登记</el-button>
        </div>


      </el-form>


    </div>
    <div style="height:20px"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      openid: "asfljasfjdasldjfasklf",
      pmid: 0,
      loading: false,

      enterInfo: {
        firm_name: "",
        firm_num: "",
        address: "",
        firm_principal: "",
        tel: "",
        pjson: {
          xjh: ""
        }
      },
      originalPrincipal: '',
      originalTel: '',
      zphid: 0,
      job_info_list: [{}],
      job: {
        "job_name": "", "need_num": '', city: "", word_addr: "",
        experience: "", eduaction: "", english_level: "", computer_level: "",
        pay: "", job_desc: ""
      },
      fileList: [],


      qyxz: [],
      xzfw: [],
      xlyq: [],
      gzjy: [],
      wyyq: [],
      jsjyq: [],
      gwshzz: [],
      professions: [],
      fldys: [],
      companyInfo: {},
      houxuanList: [],

    };
  },
  mounted() {
    let _this = this
    document.title = "校企招聘平台"
    this.openid = this.$route.query.openid
    this.pmid = this.$route.query.pmid || 210

    this.$nextTick(() => {
      _this.$forceUpdate()
    })
    // this.getList()
    this.getComType()
  },
  methods: {

    maskName(name) {
      if (!name) return ''
      if (name.length <= 1) return '*'
      return name[0] + '*'.repeat(name.length - 1)
    },

    maskPhone(phone) {
      if (!phone) return ''
      phone = phone.toString()
      if (phone.length < 7) return phone
      return phone.slice(0, 3) + '****' + phone.slice(-4)
    },

    remoteMethod(query) {
      this.enterInfo.firm_name_temp = query
    },

    qccApiData() {
      this.$http.post(`/api/tyc_search_list`, { enter_name: this.enterInfo.firm_name_temp }).then((res) => {
        this.loading = false
        if (res.data && res.data.length > 0) {
          let arr = this._lo.remove(res.data, function (n) {
            return n.creditCode && n.creditCode != '';
          })
          this.houxuanList = arr
          this.$refs.selectSearch.toggleMenu()
        }
      })
    },
    saveNewCompany(name) {
      let company = {}
      if (!this.enterInfo.firm_name_temp) {
        this.$message.error('请先查询企业并选择！')
        return;
      }
      this.houxuanList.map(a => {
        if (a.name == name) {
          company = a
        }
      })
      this.enterInfo.firm_name = company.name || name
      //天眼查的接口公司类型
      let companyType = { 1: "公司", 2: "香港企业", 3: "社会组织", 4: "律所", 5: "事业单位", 6: "基金会", 7: "不存在法人、注册资本、统一社会信用代码、经营状态; ", 8: "台湾企业", 9: "新机构" }

      company.info = 3//默认是私营企
      if (company.companyType == 5) {
        for (let item of this.qyxz) {
          if (item.param_desc == "国有企业") {
            company.info = item.param_value
          }
        }
      } else {
        if (company.name.indexOf("股份有限公司") > 0) {//股份有限公司
          for (let item of this.qyxz) {
            if (item.param_desc == "股份制企业") {
              company.info = item.param_value
            }
          }
        } else if (company.name.indexOf("有限责任公司") > 0 || company.name.indexOf("有限公司") > 0) {//股份有限公司
          for (let item of this.qyxz) {
            if (item.param_desc == "个人独资企业" || item.param_desc == '有限责任公司(自然人独资)') {
              company.info = item.param_value
            }
          }
        } else {
          for (let item of this.qyxz) {
            if (item.param_desc == "个人独资企业" || item.param_desc == '有限责任公司(自然人独资)') {
              company.info = item.param_value
            }
          }
        }
      }

      this.companyInfo = company
      this.$http.post("/api/ngz_h5_enterprise_edith5", {
        firm_name: company.name,
        firm_num: company.creditCode,
        firm_principal: company.legalPersonName,
        info: company.info,
        address: "",
        pmid: this.pmid
      }).then(res => {
        if (res.data.id) {
          this.enterInfo.enter_id = res.data.id
          this.getCompanyInfo(res.data.id)
        }
      })
    },
    getCompanyInfo(id) {
      this.$http.post("/api/ngz_h5_enterprise_info", { id: id, pmid: this.pmid }).then(res => {
        let i = 0
        for (let item of this.qyxz) {
          if (item.param_value == res.data.info) {

            break
          }
          i++
        }
        if (i >= this.qyxz.length) {
          i = 2
        }
        this.companyInfo.firm_name = res.data.firm_name
        this.companyInfo.firm_num = res.data.firm_num
        this.companyInfo.id = id;
        this.companyInfo.info = res.data.info;
        if (res?.data?.jobList) {
          let jobList = []
          for (let item of res.data.jobList) {
            if (item.check_status != 3) {
              jobList.push(item)
            }
          }
          this.companyInfo.jobList = jobList;
          this.job_info_list = jobList
        }
        if (res?.data?.tyc?.tyc_json) {
          this.companyInfo.address = res.data.tyc.tyc_json.regLocation || '';
        }
        if (res?.data?.firm_principal) {
          this.originalPrincipal = res.data.firm_principal || '';
          this.companyInfo.firm_principal = this.maskName(this.originalPrincipal);
        }
        if (res?.data?.tel) {
          this.originalTel = res.data.tel || '';
          this.companyInfo.tel = this.maskPhone(this.originalTel);
        }
        let companyInfo = JSON.parse(JSON.stringify(this.companyInfo))
        delete companyInfo.id
        this.enterInfo = Object.assign({}, this.enterInfo, companyInfo)
        console.log(309, this.enterInfo)
      })
    },


    getComType() {
      return new Promise(resolve => {
        let salaryType = window.pmid == 220 ? 'SALARY_RANGE_ZP' : 'SALARY_RANGE'
        this.$http
          .post("/api/sys_param_list", {
            param_type:
              "'ENTER_INFO','" + salaryType + "','EDUACTION','EXPERIENCE','ENGLISH_LEVEL','COMPUTER_LEVEL','GWSHZT','PROFESSIONS','FLDY'",
            used: 0,
            pmid: this.pmid
          })
          .then(res => {
            let qyxz = []; //企业性质
            let xzfw = []; //薪资类型
            let xlyq = []; //学历类型
            let gzjy = []; //工作经验
            let wyyq = []; //外语要求
            let jsjyq = []; //计算机要求
            let gwshzz = []; //计算机要求
            let professions = []; //计算机要求
            let fldy = []
            for (let item of res.data) {
              if (item.param_type == "ENTER_INFO") {
                qyxz.push(item);
              }
              if (item.param_type == salaryType) {
                if (item.param_value == 0) item.param_desc = '面议'
                xzfw.push(item);
              }
              if (item.param_type == "EDUACTION") {
                xlyq.push(item);
              }
              if (item.param_type == "EXPERIENCE") {
                gzjy.push(item);
              }
              if (item.param_type == "ENGLISH_LEVEL") {
                wyyq.push(item);
              }
              if (item.param_type == "COMPUTER_LEVEL") {
                jsjyq.push(item);
              }
              if (item.param_type == "GWSHZT") {
                gwshzz.push(item);
              }
              if (item.param_type == "PROFESSIONS") {
                professions.push(item);
              }
              if (item.param_type == 'FLDY') {
                fldy.push(item);
              }
            }
            this.qyxz = qyxz;
            this.xzfw = xzfw;
            this.xlyq = xlyq;
            this.gzjy = gzjy;
            this.wyyq = wyyq;
            this.jsjyq = jsjyq;
            this.gwshzz = gwshzz;
            this.professions = professions;
            this.fldys = fldy
            resolve();
          });
      });
    },
    getList() {
      this.$http.post("/api/get_enter_info_byopenid", { pmid: this.pmid, openid: this.openid }).then(res => {
        if (res.data) {
          let enterInfo = res.data
          if (res.data.zph) {
            this.job_info_list = JSON.parse(res.data.zph.job_info_list)
            enterInfo.pjson = JSON.parse(res.data.zph.pjson)
            this.zphid = res.data.zph.id
          } else {
            this.job_info_list = [{ ...this.job }]
            enterInfo.pjson = {
              xjh: ""
            }
          }
          if (res.data.files) {
            this.fileList = JSON.parse(res.data.files)
          }
          this.enterInfo = enterInfo

        } else {
          this.job_info_list = [{ ...this.job }]

        }
      })
    },
    addJob() {
      this.job_info_list.push({ ...this.job })
      this.$nextTick(e => {
        $(".h5bg").scrollTop(99999)
      })
    },
    removeJob(i) {
      let _this = this
      const job = this.job_info_list[i]
      const hasValue = job.job_name || job.need_num || job.city || job.word_addr

      if (hasValue) {
        this.$confirm('确定要删除该岗位吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.job_info_list.splice(i, 1)
          if (job?.id) {
            _this.handleDelete(job.id).then(() => {
              // _this.getCompanyInfo( _this.enterInfo.enter_id)
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.job_info_list.splice(i, 1)
      }
    },
    handleDelete(id) {
      return new Promise(resolve => {
        this.$http
          .post("/api/zp_job_info_audit", {
            id: id,
            check_status: 3
          })
          .then(res => {
            resolve()
          });
        resolve()
      })
    },
    checkTyc() {
      this.$http.post("/api/tyc_search", { enter_name: this.enterInfo.firm_name }).then(res => {
        if (res.data) {
          this.enterInfo.firm_name = res.data.name
          this.enterInfo.address = res.data.regLocation
          this.enterInfo.firm_num = res.data.creditCode
        }
      })
    },
    uploadFiles(e) {
      this.fileList.push(e)
    },
    removeImg(idx) {
      this.fileList.splice(idx, 1)
    },
    checkEnterSuccess() {

    },

    saveForm() {
      if (!this.enterInfo.firm_name.trim()) {
        this.$message({
          message: "请输入企业全称",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }
      if (!this.enterInfo.address.trim()) {
        this.$message({
          message: "请输入企业地址详情",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }
      if (!this.enterInfo.firm_principal.trim()) {
        this.$message({
          message: "请输入企业联系人",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }
      if (!this.enterInfo.tel.trim()) {
        this.$message({
          message: "请输入企业联系人电话",
          type: 'error',
          customClass: "toast",
          duration: 2000
        });
        return
      }

      //检查岗位有没有填写
      let jobok = false
      for (let job of this.job_info_list) {
        let hasValue = job.job_name || job.need_num || job.city || job.word_addr
        if (!hasValue) {
          this.$message({
            message: "请完善岗位信息",
            type: 'error',
            customClass: "toast",
            duration: 2000
          });
          return
        }
      }
      // if (this.pmid == 216 && (!this.fileList || this.fileList.length == 0)) {
      //   this.$message({
      //     message: "请上传营业执照和企业相关照片（办公场所、宿舍、食堂）",
      //     type: 'error',
      //     customClass: "toast",
      //     duration: 2000
      //   });
      //   return
      // }
      this.loading = true
      let data = { ...this.enterInfo }
      data.job_info_list = this.job_info_list
      data.pjson = this.enterInfo.pjson
      data.pmid = this.pmid
      data.openid = this.openid
      data.id = this.enterInfo.id
      data.zphid = this.zphid
      data.files = JSON.stringify(this.fileList)
      
      if (this.originalPrincipal && this.enterInfo.firm_principal === this.maskName(this.originalPrincipal)) {
        data.firm_principal = this.originalPrincipal
      }
      if (this.originalTel && this.enterInfo.tel === this.maskPhone(this.originalTel)) {
        data.tel = this.originalTel
      }
      
      this.$http.post("/api/ngz_h5_enterprise_dengji", data).then(res => {
        this.$message({
          message: "岗位登记成功，感谢您的参与！",
          type: 'success',
          customClass: "toast",
          duration: 5000
        });
        this.loading = false
        this.getList()
      })
    }
  }
};
</script>


<style scoped lang="scss">
.h5bg {
  ::deep(.el-message-box) {
    width: unset;
  }

  ::deep(.el-form-item__label) {
    padding: 10px 0 0;
  }
}

.el-form--label-top .el-form-item__label {
  margin-bottom: 0;
  padding: 0;
}

.toast {
  width: 80%;
  min-width: 10% !important;
  max-width: 350px !important;
}

.imgaddbtn {
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dotted #ccc;
  font-size: 30px;
  cursor: pointer;
}

.imgremove {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;

  cursor: pointer;
  position: absolute;
  top: -5px;
  right: -5px;
  color: #ccc;
}

.imgremove:hover {
  color: orange;
}
</style>
<style scoped lang="scss">
::deep(.el-message-box) {
  width: unset;
}


.h5bg {
  background-image: url(../../../public/img/pingding_index_bg.png);
  background-size: 100% 100%;
  height: 100vh;
  overflow: auto;

  ::deep(.el-message-box) {
    width: unset;
  }
}

.section-title {
  padding-top: 15px;
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
}

.section-title span {
  display: inline-block;
  width: 4px;
  height: 16px;
  background-color: #1890ff;
  margin-right: 8px;
  vertical-align: middle;
}

.section-title.required span {
  background-color: #f5222d;
}

.section-title1 {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #666;
  border-bottom: none;
  margin-bottom: 10px;
}

.section-title1 span {
  width: 3px;
  height: 14px;
  background-color: #1890ff81;
  margin-right: 6px;
}

.remove-btn {
  /* margin-left: auto; */
  margin-left: 15px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.remove-btn img {
  width: 100%;
  height: 100%;
}

.btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.add-btn {
  width: 20px;
  height: 20px;
  margin: 0 auto;
}

.add-btn img {
  width: 100%;
  height: 100%;
}

.tags {
  span {
    font-size: 14px;
    padding: 1px 5px;
    border-radius: 4px;
    border: 1px solid #303133;
    // margin-left: 5px;
  }

  .style0 {
    color: #3378fa;
    border-color: #3378fa;
  }

  .style1 {
    color: #19c295;
    border-color: #19c295;
  }

  .style2 {
    color: #ef342e;
    border-color: #ef342e;
  }

  .style3 {
    color: #c0c4cc;
    border-color: #c0c4cc;
  }

}
</style>
